<template>
  <div class="pamer-tiada-akses">
    <v-container class="fill-height" style="min-height: 70vh">
      <v-row justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="6">
          <v-card outlined class="pa-8 text-center">
            <v-icon size="72" color="amber darken-2">mdi-lock-outline</v-icon>

            <h2 class="text-h5 font-weight-bold mt-5">Anda tidak mempunyai akses</h2>

            <v-alert type="warning" text class="mt-5 mb-0 text-left">
              Anda tidak mempunyai akses. Sila pergi ke <b>Sistem HIES/BA Tangkapan Data</b>.
            </v-alert>

            <v-btn
              v-if="url"
              color="primary"
              large
              class="mt-6 text-none"
              :href="url"
              target="_blank"
              rel="noopener"
            >
              <v-icon left>mdi-open-in-new</v-icon>
              Pergi ke Sistem HIES/BA Tangkapan Data
            </v-btn>
            <div v-if="url" class="caption grey--text mt-2 text-truncate" :title="url">{{ url }}</div>

            <v-alert v-else-if="loaded" type="info" text dense class="mt-6 mb-0">
              Alamat Sistem HIES/BA Tangkapan Data belum ditetapkan. Sila hubungi pentadbir sistem.
            </v-alert>

            <div class="mt-6">
              <v-btn text small color="grey darken-1" class="text-none" :href="homeHref">
                <v-icon left small>mdi-home</v-icon> Kembali ke Paparan Utama
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/i18n";
import axios from "../../plugins/axios";

const API = process.env.VUE_APP_API_URL;

export default {
  name: "Pamerdatahiestiadaakses",
  data() {
    return {
      url: "",
      loaded: false,
    };
  },
  computed: {
    homeHref() {
      return `/${i18n.locale}/paparanutama`;
    },
  },
  mounted() {
    this.loadUrl();
  },
  methods: {
    // permissions/me is intentionally ungated so a blocked role can still learn
    // where to go. It returns urlSistemTangkapanData from analisis_config.
    async loadUrl() {
      try {
        const res = await axios.get(`${API}/penerbitan/permissions/me`);
        this.url = (res.data && res.data.data && res.data.data.urlSistemTangkapanData) || "";
      } catch (e) {
        this.url = "";
      } finally {
        this.loaded = true;
      }
    },
  },
};
</script>
